import { Modal } from "react-bootstrap";
import { defineMessages, injectIntl } from "react-intl";
import PropTypes from "prop-types";
import useI18n from "../hooks/useI18n";

const messages = defineMessages({
    title: {
        id: "Ota yhteyttä",
        defaultMessage: "Contact us"
    },
    fi: {
        id: "Suomi",
        defaultMessage: "Finland"
    },
    se: {
        id: "Ruotsi",
        defaultMessage: "Sweden"
    },
    no: {
        id: "Norja",
        defaultMessage: "Norway"
    },
    info: {
        id: "Valitse maasi ottaaksesi yhteyttä paikalliseen tukeen.",
        defaultMessage: "Select your country to contact local support."
    },
    close: {
        id: "Sulje",
        defaultMessage: "Close"
    }
});

const ContactFormModal = ({ show, onHide, intl }) => {
    const lng = intl.formatMessage;
    const { systemCountries, getCountryFlag } = useI18n();

    const countries = systemCountries.filter(c => c.contactUrl);

    return (
        <Modal show={show} onHide={onHide} id="contact-form-modal" centered>
            <Modal.Header closeButton>
                <Modal.Title>{lng(messages.title)}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="text-muted">{lng(messages.info)}</p>
                <div className="d-flex flex-column gap-2">
                    {countries.map((country) => (
                        <a
                            key={country.locale}
                            href={country.contactUrl}
                            className="btn country-selection-modal-item"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <span>
                                <img src={getCountryFlag(country.locale)} alt="" aria-hidden="true" width={20} height={20} />
                            </span>
                            <span className="url">
                                {country.contactUrl.replace('https://', '').split('/')[0]}
                            </span>
                            <span>
                                ({lng(messages[country.locale])})
                            </span>
                        </a>
                    ))}
                </div>
            </Modal.Body>
        </Modal>
    );
};

ContactFormModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired
};

export default injectIntl(ContactFormModal);